import React from 'react';
import { X } from 'lucide-react';

const formatCurrency = (amount) => `RF ${Math.round(amount || 0).toLocaleString()}`;

const PricingBreakdownModal = ({
  isOpen,
  onClose,
  rentalDays,
  breakdown = [],
  basePrice = 0,
  outsideCityFee = 0,
  serviceFee = 0,
  totalPrice = 0
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-2xl rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-5">
          <div>
            <p className="text-[10px] font-black uppercase tracking-[0.18em] text-gray-400 mb-2">Pricing Breakdown</p>
            <h3 className="text-2xl font-black tracking-tight">How your amount was calculated</h3>
          </div>
          <button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-6 space-y-6">
          <div className="rounded-2xl border border-gray-100 bg-gray-50 p-4">
            <p className="text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2">Rental Duration</p>
            <p className="text-sm font-black text-gray-900">{rentalDays || 0} day(s)</p>
          </div>

          <div className="space-y-3">
            {breakdown.map((item, index) => (
              <div key={`${item.pricingType}-${index}`} className="rounded-2xl border border-gray-100 p-4">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <p className="text-sm font-black text-gray-900">{item.label}</p>
                    <p className="text-[11px] text-gray-500 mt-1">{item.description}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-black text-gray-900">{formatCurrency(item.totalAmount)}</p>
                    <p className="text-[11px] text-gray-500 mt-1">
                      {item.perDay
                        ? `${formatCurrency(item.unitAmount)} x ${item.quantity} day(s)`
                        : `${formatCurrency(item.unitAmount)} x ${item.quantity} package(s)`}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-2xl border border-gray-100 bg-gray-50 p-4 space-y-3">
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-500 font-medium">Rental Total</span>
              <span className="font-black text-gray-900">{formatCurrency(basePrice)}</span>
            </div>
            {outsideCityFee > 0 && (
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500 font-medium">Outside City Fee</span>
                <span className="font-black text-gray-900">{formatCurrency(outsideCityFee)}</span>
              </div>
            )}
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-500 font-medium">Service Fee</span>
              <span className="font-black text-gray-900">{formatCurrency(serviceFee)}</span>
            </div>
            <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
              <span className="text-base font-black text-gray-900">Reservation Total</span>
              <span className="text-xl font-black text-gray-900">{formatCurrency(totalPrice)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingBreakdownModal;
